import CartFooter from './CartFooter';
export default CartFooter;
